import React, { Component } from 'react';
import { Button, Toolbar } from 'react-md';
import '../Wizard.scss';
import { ProgressBar } from '../../index';
import ReactJson from 'react-json-view';

export default class PersonWizardStep5 extends Component {
  async componentDidMount () {
    const { data, actions: { initRecursiveTree } } = this.props;

    if (data && data.relationships) {
      const branches = data.relationships.map( rel => rel.fromPartyKey);
      await initRecursiveTree(branches);
    }
  }

  componentDidUpdate () {
    const { readyBuildState, registrationTreeBranches, actions: { setFullTree } } = this.props;

    if (readyBuildState) {
      setFullTree(registrationTreeBranches);
    }

  };

  handleEmail = (send) => {
    const { data, editData, hide, actions: { confirmPerson, sendRegistrationEmail, clearSearchTerm } } = this.props;

    if (data && data.email) {
      sendRegistrationEmail({ externalKey: data.externalKey, displayName: data.displayName });
    } else {
      confirmPerson(!!data, { edits: editData, original: data && data }, send && send);
    }
    clearSearchTerm();
    hide();
  };

  back = () => {
    this.props.previousStep();
    this.props.scrollToTop();
  }

  render() {
    const { data, title, editData, fullTree, hide } = this.props;

    const toolAndProgressBar = () => {
      return (
        <div>
          <Toolbar
            fixed
            colored
            titleStyle={{ margin: '0 auto', paddingRight: '36px' }}
            title={data && data.email ? `Creating a new ${title.toLowerCase()}`: data ? `Edit ${title.toLowerCase()}` : `Creating a new ${title.toLowerCase()}`}
            nav={<Button id="dialog-back-button" onClick={this.back} icon >arrow_back</Button>}
            style={{ backgroundColor: '#6200EE' }}
          />
          <ProgressBar step={this.props.currentStep} steps={4} />
        </div>
      );
    };

    const navlessToolBar = () => {
      return (
        <Toolbar
          fixed
          colored
          titleStyle={{ margin: '0 auto', paddingRight: '36px' }}
          title={`Creating a new ${title.toLowerCase()}`}
          style={{ backgroundColor: '#6200EE' }}
        />
      );
    };

    return (
      <div className="wrapper">
        {data && data.email ? navlessToolBar():
          toolAndProgressBar()
        }
        <div className="wizard-step">
          <div className="wizard-step-header-container">
            <div className="wizard-step-header">Send registration email?</div>
            <div className="wizard-step-subheader">{`${editData ?
              `${editData.firstName} ${editData.lastName}` : data && data.email ? data.displayName : 'This user'} will be able to see the following lots in Analytics:`}</div>
          </div>
          <div id="relation-tree-container">
            <ReactJson
              src={{ associations: fullTree }}
              displayDataTypes={false}
              displayObjectSize={false}
              name={null}
              enableClipboard={false}
              onEdit={false}
              shouldCollapse={false}
            />
          </div>
          <div className="wizard-email-container">
            <Button
              id="person-wizard-registration-later"
              className="wizard-button"
              flat
              onClick={() => data && data.email ? hide() : this.handleEmail()}
            >
              NOT NOW
            </Button>
            <Button
              id="person-wizard-registration-now"
              className="wizard-button"
              flat
              onClick={() => this.handleEmail(true)}
            >
              SEND EMAIL
            </Button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard/PersonWizardStep4/PersonWizardStep4.jsx